// ============= Imports =============
import { FC, Suspense } from 'react';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { HeaderLayout } from './components/layout/headerLayout/HeaderLayout';
import { AdminHeader } from './components/layout/adminHeader/AdminHeader';
import { LoadingSpinner, ThemeProvider } from '@tw/tw-component-library';
import { BodyLayout } from './components/layout/bodyLayout/BodyLayout';
import { WorkflowProvider } from './contexts/WorkflowContext';
import { AuthProvider, UseAuth } from './contexts/AuthContext';
import { FormProvider } from './contexts/FormContext';

// Styles for react-doc-viewer
import '@cyntler/react-doc-viewer/dist/index.css';

// ============= Component =============
const AppShell: FC = () => {
  const { isAuthenticated, activeAccount, login, logout } = UseAuth();

  return (
    <ThemeProvider themeMode="winstonTaylor">
      <AdminHeader />
      <HeaderLayout
        isAuthenticated={isAuthenticated}
        activeAccount={activeAccount}
        login={login}
        logout={logout}
      >
        {isAuthenticated && (
          <AuthenticatedTemplate>
            <Suspense fallback={<LoadingSpinner variant="fullPage" />}>
              <WorkflowProvider>
                <FormProvider>
                  <BodyLayout />
                </FormProvider>
              </WorkflowProvider>
            </Suspense>
          </AuthenticatedTemplate>
        )}
      </HeaderLayout>
    </ThemeProvider>
  );
};

const App: FC = () => {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
};

export default App;
